import { useFlags } from 'launchdarkly-react-client-sdk';
import { cloneDeep, uniqBy } from 'lodash';
import { useSelector } from 'react-redux';
import { Channel, Item } from '../../../models';
import { enhanceFetchedAsset } from '../../../pages/assets/asset-listing/enhanceFetchedAsset';
import { ChannelFormData } from '../../../pages/channelmanager/channels/channel-editor/ChannelFormData';
import { AssetLookup } from '../../../utils/assetLookup';
import { fuelUserAccessSliceSelector } from '../../slices/fuelUserAccess';

export class LodTransitionsForm {
  // StartupRecorded: string[] = [];
  // startupRecordedSelection: Item | null = null;

  transitionEnabled: boolean = false;
  transitionTemplateId: string | null = null;
  transitionTemplateSelection: any | null = null;

  startUpRecordedFillers: Item[] = [];

  static createFromData(data: ChannelFormData, permissions, flags, ouData) {
    const form = new LodTransitionsForm();
    form.loadData(data, permissions, flags, ouData);
    return form;
  }

  loadData(data: ChannelFormData, permissions, flags, ouData) {
    const { channel, assets, transitionTemplate } = data;

    const assetLookup = new AssetLookup(assets);

    // this.loadStartupRecordedFromMetadata(channel, assetLookup);
    this.loadStartupRecordedFillersFromMetadata(channel, assetLookup, permissions, flags, ouData);

    // normalize out undefined as a possible value...
    if (channel.transitionEnabled !== undefined) this.transitionEnabled = channel.transitionEnabled;

    if (channel.transitionTemplateId) {
      this.transitionTemplateId = channel.transitionTemplateId;
      this.transitionTemplateSelection = transitionTemplate;
    }
  }

  // private loadStartupRecordedFromMetadata(channel: Channel, assetLookup: AssetLookup) {
  //   const liveFillers = channel.metaData.fillers;
  //   if (liveFillers) {
  //     if (liveFillers && liveFillers.StartupRecorded && liveFillers.StartupRecorded.length) {
  //       this.StartupRecorded = liveFillers.StartupRecorded;
  //       const item = assetLookup.smartGetById(this.StartupRecorded[0]);
  //       if (item == null) {
  //         throw new Error(
  //           `Loading LOD transitions, couldn't find asset in lookup, asset id: ${this.StartupRecorded[0]}`,
  //         );
  //       }
  //       this.startupRecordedSelection = item;
  //     }
  //   }
  // }
  private loadStartupRecordedFillersFromMetadata(channel: Channel, assetLookup: AssetLookup, permissions, flags, ouData) {
    const startUpRecordedFillers = channel.metaData.fillers.StartupRecorded;
    if (startUpRecordedFillers && startUpRecordedFillers.length) {
      const itemIds = startUpRecordedFillers;
      this.startUpRecordedFillers = itemIds.map((itemId) => {
        const item = assetLookup.smartGetById(itemId);
        const newItem = enhanceFetchedAsset(cloneDeep(item), permissions, flags, true, channel.metaData?.variantCodes, [], ouData);
        return newItem;
      });
    }
  }
}
